import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { TreatmentEdit } from "@/features/catalog";
import { treatmentDefinitionRouteId } from "@/features/catalog/lib/treatment-definition-route";

export const Route = createFileRoute("/catalog/treatments/new")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canWrite("ActivityDefinition")) throw redirect({ to: "/catalog/procedures" });
  },
  component: NewTreatment,
});

function NewTreatment() {
  const navigate = useNavigate();
  return (
    <TreatmentEdit
      canEdit
      onDone={(url) =>
        url
          ? navigate({
              to: "/catalog/treatments/$treatmentId",
              params: { treatmentId: treatmentDefinitionRouteId(url) },
            })
          : navigate({ to: "/catalog/procedures" })
      }
      onCancel={() => navigate({ to: "/catalog/procedures" })}
    />
  );
}
